<template>
	<div class="risk-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.business_risk_page_v2.sec_01.title.one') }}<br />
					<strong>{{
						$t('new_ui.business_risk_page_v2.sec_01.title.two')
					}}</strong
					>{{ $t('new_ui.business_risk_page_v2.sec_01.title.three')
					}}<strong>{{
						$t('new_ui.business_risk_page_v2.sec_01.title.four')
					}}</strong>
				</h2>
				<p>
					{{ $t('new_ui.business_risk_page_v2.sec_01.desc.one') }}<br />
					{{ $t('new_ui.business_risk_page_v2.sec_01.desc.two') }}
				</p>
			</div>
		</section>
		<section class="sec-14">
			<div class="container-box">
				<p>{{ $t('new_ui.business_risk_page_v2.sec_14.desc.one') }}</p>
				<a href="/service/cs/cs" class="btn-type-03">
					{{ $t('new_ui.business_risk_page_v2.sec_14.btn') }}
					<img :src="img.iconArrowRightCircle" alt="" />
				</a>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="title-box">
					<h3>
						{{ $t('new_ui.business_risk_page_v2.sec_03.title.one') }}
					</h3>
					<p>
						{{ $t('new_ui.business_risk_page_v2.sec_03.desc.one') }}<br />
						{{ $t('new_ui.business_risk_page_v2.sec_03.desc.two') }}
					</p>
				</div>
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_risk_page_v2.sec_03.one.title.one') }}
						</h3>
						<p>
							{{ $t('new_ui.business_risk_page_v2.sec_03.one.desc.one') }}<br />
							{{ $t('new_ui.business_risk_page_v2.sec_03.one.desc.two') }}
						</p>
					</div>
					<div class="img-box">
						<img :src="img.imgRiskSec0301" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgRiskSec0302" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_risk_page_v2.sec_03.two.title.one') }}
						</h3>
						<p>
							{{ $t('new_ui.business_risk_page_v2.sec_03.two.desc.one') }}
							<br />
							{{ $t('new_ui.business_risk_page_v2.sec_03.two.desc.two') }}
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import iconArrowRightCircle from '@/assets/images/v2/icon/icon-arrow-right-circle.svg';
import imgRiskSec0301 from '@/assets/images/v2/img-risk-sec-03-01.png';
import imgRiskSec0302 from '@/assets/images/v2/img-risk-sec-03-02.png';

export default {
	data: () => {
		return {
			img: {
				iconArrowRightCircle,
				imgRiskSec0301,
				imgRiskSec0302,
			},
		};
	},
};
</script>
